<template>
    <LazyLoad
        v-if="!!leftContent"
        class="c-catalog-in-grid-row o-extra-small--12 o-large--6"
        bottomMargin="100px"
        @click="() => handleInGridContentClick(shapedLeftContent)"
        v-slot="{ hasEnteredViewport }"
    >
        <AsyncContentFadeIn class="c-catalog-in-grid-row__content" :hasMetMinimLoadTime="hasEnteredViewport">
            <ContentfulModule
                :module="shapedLeftContent"
                :numberOfModules="1"
            />
        </AsyncContentFadeIn>
    </LazyLoad>
    <LazyLoad
        v-if="!!rightContent"
        class="c-catalog-in-grid-row o-extra-small--12 o-large--6"
        bottomMargin="100px"
        @click="() => handleInGridContentClick(shapedRightContent)"
        v-slot="{ hasEnteredViewport }"
    >
        <AsyncContentFadeIn class="c-catalog-in-grid-row__content" :hasMetMinimLoadTime="hasEnteredViewport">
            <ContentfulModule
                :module="shapedRightContent"
                :numberOfModules="1"
            />
        </AsyncContentFadeIn>
    </LazyLoad>
</template>

<script setup>
import { toRef, computed } from 'vue';

import { useActions } from '~coreModules/core/js/composables/vuexHelpers';

import { GLOBAL_EVENT } from '~coreModules/core/js/store';
import { IN_GRID_CONTENT_CLICKED } from '~coreModules/core/js/global-event-constants';

import AsyncContentFadeIn from '~coreModules/core/components/ui/AsyncContentFadeIn.vue';
import LazyLoad from '~coreModules/core/components/ui/LazyLoad.vue';

import ContentfulModule from '~modules/contentful/components/ContentfulModule.vue';

const props = defineProps({
    contentfulInGridContent: {
        type: Object,
        default: null,
    },
    contentfulTitle: {
        type: String,
        default: null,
    },
    contentfulStartTime: {
        type: String,
        default: null,
    },
    contentfulEndTime: {
        type: String,
        default: null,
    },
    pagination: {
        type: Object,
        default: () => {},
    },
});

const { trackGlobalEvent } = useActions({ trackGlobalEvent: GLOBAL_EVENT });

/* eslint-disable vue/no-setup-props-reactivity-loss */
const leftContent = toRef(props.contentfulInGridContent, 'leftContent');
const rightContent = toRef(props.contentfulInGridContent, 'rightContent');
const index = toRef(props.contentfulInGridContent, 'injectionIndex');
/* eslint-enable vue/no-setup-props-reactivity-loss */

function analyticsInjectionIndex(injectionIndex) {
    return (((props.pagination?.pageNumber || 0) - 1) * (props.pagination?.itemsPerPage || 0)) + injectionIndex;
}

const shapedLeftContent = computed(() => ({
    ...leftContent.value,
    stretchImageToContainer: true,
    injectionIndex: analyticsInjectionIndex(index.value),
}));
const shapedRightContent = computed(() => ({
    ...rightContent.value,
    stretchImageToContainer: true,
    injectionIndex: analyticsInjectionIndex(leftContent.value ? index.value + 1 : index.value),
}));

function handleInGridContentClick({
    destination,
    injectionIndex,
    title,
}) {
    trackGlobalEvent({
        type: IN_GRID_CONTENT_CLICKED,
        data: {
            contentModuleId: title,
            destination: destination?.linkPath,
            index: injectionIndex,
            contentTitle: props.contentfulTitle,
            contentStartTime: props.contentfulStartTime,
            contentEndTime: props.contentfulEndTime,
        },
    });
}

</script>

<style lang="scss">
.c-catalog-in-grid-row {
    position: relative;
    overflow: hidden;

    @include breakpoint(extra-extra-large) {
        grid-column-end: span 10;
    }

    &__content {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }

    .c-image-module__img-wrapper {
        height: 100%;
        outline-offset: -4px;
    }
}
</style>
